import { gql } from "@apollo/client";export default gql`mutation deleteStudent($id: Int!) {
    deleteStudent: delete_student_by_pk(id: $id) {
        id
    }
}
`;
